import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function Inventory() {
  const [items, setItems] = useState([]);
  const [stock, setStock] = useState([]);
  useEffect(() => {
    api.get("/inventory/items").then(({ data }) => setItems(data)).catch(() => {});
    api.get("/inventory/stock").then(({ data }) => setStock(data)).catch(() => {});
  }, []);

  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-4 sm:space-y-6" data-testid="sales-inventory">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-black">Inventory visibility</h1>
        <p className="text-muted-foreground">Read-only view of warehouse stock, reserved and incoming quantities. Updates flow from Procurement / Manufacturing.</p>
      </div>
      <div className="surface-card p-4 overflow-x-auto">
        <Table>
          <TableHeader><TableRow><TableHead>Item</TableHead><TableHead>Warehouse</TableHead><TableHead>On hand</TableHead><TableHead>Reserved</TableHead><TableHead>Avg cost</TableHead></TableRow></TableHeader>
          <TableBody>
            {stock.map((s) => {
              const item = items.find((i) => i.id === s.item_id);
              return (
                <TableRow key={`${s.item_id}-${s.warehouse_id}`} data-testid={`stock-row-${s.item_id}`}>
                  <TableCell className="font-semibold">{item?.name || s.item_id.slice(0,8)}<div className="text-[10px] text-muted-foreground">{item?.code}</div></TableCell>
                  <TableCell className="font-mono text-xs">{s.warehouse_id?.slice(0,8) || "—"}</TableCell>
                  <TableCell>{s.qty_on_hand ?? s.qty ?? 0}</TableCell>
                  <TableCell><Badge variant="outline">{s.reserved || 0}</Badge></TableCell>
                  <TableCell>₹{(s.avg_cost || 0).toFixed(2)}</TableCell>
                </TableRow>
              );
            })}
            {stock.length === 0 && <TableRow><TableCell colSpan={5} className="text-center text-muted-foreground py-10">No stock visible yet.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
